const EDITIONS = [
  {
    id: "v1",
    version: "1.0",
    name: "Hoodies 1.0",
    year: "The Original",
    colour: "Heather Grey",
    description:
      "Where it all started. A soft heather-grey pullover with the LB mark in black on the chest — the first hoodie we ever made, and the one that set the fit for everything since.",
    details: [
      "Relaxed everyday fit",
      "Brushed heather fleece",
      "Black LB chest mark",
    ],
    image: "/products/hoodie-v1-front.jpg",
    hoverImage: "/products/hoodie-v1-back.jpg",
  },
];

const Edition = ({ e, i }) => (
  <article
    data-testid={`history-edition-${e.id}`}
    className={`grid md:grid-cols-12 gap-8 md:gap-12 items-center ${i > 0 ? "mt-20" : ""}`}
  >
    <div className={`md:col-span-6 ${i % 2 ? "md:order-2" : ""}`}>
      <div className="group relative overflow-hidden aspect-[4/5] border border-ink/10 bg-white">
        <img
          src={e.image}
          alt={`LeapBodies ${e.name} — front`}
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <img
          src={e.hoverImage}
          alt={`LeapBodies ${e.name} — back`}
          loading="lazy"
          data-testid={`history-edition-${e.id}-hover-image`}
          className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        />
        <span className="absolute bottom-3 left-3 bg-[#111111]/70 text-[#F9F8F5] font-mono text-[10px] uppercase tracking-[0.2em] px-2.5 py-1.5 group-hover:opacity-0 transition-opacity duration-300">
          Hover to see back
        </span>
      </div>
    </div>
    <div className="md:col-span-6">
      <p className="font-serif text-6xl sm:text-7xl leading-none text-oxblood/90">
        {e.version}
      </p>
      <p className="mt-4 font-mono text-[11px] tracking-[0.25em] uppercase text-mutedink">
        {e.year} · {e.colour}
      </p>
      <h3 className="mt-2 font-serif text-2xl sm:text-3xl text-ink">
        {e.name}
      </h3>
      <p className="mt-4 max-w-md text-sm text-[#2A2A2A] leading-relaxed">
        {e.description}
      </p>
      <ul className="mt-6 space-y-2">
        {e.details.map((d) => (
          <li key={d} className="flex items-center gap-3 text-sm text-mutedink">
            <span aria-hidden="true" className="w-5 h-px bg-oxblood/60" />
            {d}
          </li>
        ))}
      </ul>
    </div>
  </article>
);

export const HoodieHistory = () => (
  <section
    data-testid="hoodie-history-section"
    className="mt-24 border-t border-ink/10 pt-14"
  >
    <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-mutedink mb-3">
      The Archive
    </p>
    <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-ink mb-3">
      History of LeapHoodies.
    </h2>
    <p className="max-w-xl text-sm text-mutedink leading-relaxed mb-14">
      Every version we have made, in order — from the first heather-grey
      pullover to the hoodies you see above.
    </p>
    {EDITIONS.map((e, i) => (
      <Edition key={e.id} e={e} i={i} />
    ))}
  </section>
);
